import { LocalSeeTwoTone } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import useSWR from "swr";
import { refreshTables } from "../Store/atoms";

export const BASE_URL = "http://localhost:3521/api/";
export const URL = `${process.env.URL}/api/`;

export const fetcher = (url: string) =>
  fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      "X-Auth": getAuth(),
    },
  })
    .then((res) => {
      return res;
    })
    .then((res) => res.json());

export const getAuth = () => {
  const id = localStorage.getItem("userId");
  const token = localStorage.getItem("jwt");

  if (id === null || token === null) {
    return "";
  }

  return id + " " + token;
};

export const postLogin = async (url: string, data: any) => {
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });

  const user = await response.json();

  return user;
};

export const extractId = (path: string) => {
  const end = path.lastIndexOf("/");

  if (path.length === end + 1 || end === -1) {
    return 0;
  }
  const res = +path.slice(end + 1, path.length);
  if (Number.isNaN(res)) {
    return 0;
  }

  return res;
};

export const sendData = async (url: string, method: string, data: any) => {
  // Default options are marked with *
  const response = await fetch(url, {
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      "X-Auth": getAuth(),
    },
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });

  const result = await response.json();

  return result;
};

export const sendFile = async (url: string, data: any) => {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "X-Auth": getAuth(),
    },
    body: data,
  });

  const result = await response.json();

  return result;
};
